import React from 'react'

import { ObjectFieldsFilterV4 as Filters } from 'features/records/components/RecordFilters'
import { Widget, WidgetAdminControlsProps } from 'features/views/LayoutEditor/types'

import { Box } from 'ui/components/Box'
import { Button } from 'ui/components/Button'
import { Body } from 'ui/components/Text'

import { useLayoutEditorVisibilityFiltersControlState } from './hooks/useLayoutEditorVisibilityFiltersControlState'
import { LayoutEditorCollapsibleControl } from './LayoutEditorCollapsibleControl'

type LayoutEditorVisibilityFiltersControlProps = Partial<
    React.ComponentPropsWithoutRef<typeof LayoutEditorCollapsibleControl>
> & {
    widget: Widget
    onChange: WidgetAdminControlsProps<Widget>['onChange']
}

export const LayoutEditorVisibilityFiltersControl: React.FC<
    LayoutEditorVisibilityFiltersControlProps
> = ({ widget, onChange, ...props }) => {
    const { object, fields, visibilityFilters, onChangeVisibilityFilters } =
        useLayoutEditorVisibilityFiltersControlState({ widget, onChange })

    return (
        <LayoutEditorCollapsibleControl
            label="Conditional visibility"
            startIcon={{ name: 'Eye' }}
            defaultOpen={false}
            {...props}
        >
            <Body size="s" mb="l" display="block">
                Conditional visibility lets you show and hide an element, based on a filter. This
                only changes the appearance of the app, and is not a security feature.
            </Body>
            <Filters
                object={object}
                value={visibilityFilters}
                showRoleFilter
                fields={fields}
                onChange={onChangeVisibilityFilters}
                withHeader={false}
                place="bottom-end"
                hideTheRecordFilter={false}
                customButtonRender={(props) => (
                    <Box>
                        <Button
                            {...props}
                            size="2xs"
                            variant="primary"
                            startIcon={{ name: 'Plus' }}
                        >
                            Add filter
                        </Button>
                    </Box>
                )}
            />
        </LayoutEditorCollapsibleControl>
    )
}
